export class Photo {
    /**
     * @public
     * @type {Guid}
     */
    photoId;

    /**
     * @public
     * @type {HTMLImageElement}
     */
    photoHtmlImage;

    /**
     * @public
     * @type {{x:number, y:number, width:number, height:number, originalCenterPointX:number, originalCenterPointY:number}}
     */
    crop;

    /**
     * @public
     * @type {number}
     */
    flip;

    /**
     * @public
     * @type {number}
     */
    rotation;

    /**
     * @public
     * @type {number}
     */
    originalAspectRatio; //tmp

    /**
     * @public
     * @type {string}
     */
    filter;
    constructor(photoId, photoHtmlImage, crop, flip, rotation, originalAspectRatio, filter) {
        this.photoId = photoId;
        this.photoHtmlImage = photoHtmlImage;
        this.crop = crop;
        this.flip = flip;
        this.rotation = rotation;
        this.originalAspectRatio = originalAspectRatio;  
        this.filter = filter;
    }

    /*static generatefillPatternCanvas(image, destWidth, destHeight, filter) {
        const canvas = document.createElement('canvas');
        let scale = Math.max(destWidth / image.naturalWidth, destHeight / image.naturalHeight);
        canvas.width = image.naturalWidth * scale;
        canvas.height = image.naturalHeight * scale;

        // Pobierz kontekst 2D
        const ctx = canvas.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'medium';

        // Zastosowanie filtru
        ctx.filter = filter || '';

        // Narysuj obrazek na canvasie
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        return canvas;
    }*/
}